/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Input,
  Modal,
  message,
  Empty,
} from 'antd';
import { CheckCircleOutlined, EyeOutlined, FileSearchOutlined } from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import Select from 'components/Select';
import { getEstadosGlobales } from 'api/catalogos/index';
import {
  getNivelesDeEstudios,
  postNivelDeEstudio,
  deleteNivelDeEstudio,
  patchNivelDeEstudio,
  getNivelDeEstudio,
  autorizarNivelDeEstudio,
} from 'api/catalogos/nivelesDeEstudios';
import API from 'utils/api';
import { checkToken } from 'api/utils';
import { NOMBRES_PATTERN } from 'utils/patterns';
import {
  ESTATUS_ACTIVO,
  ESTATUS_INACTIVO,
  ESTATUS_AUTORIZADO,
} from 'utils/constants';
import { getEntrevistaInforme, getEntrevistasInforme, getResultados } from 'api/EntrevistasInforme';
import { getCandidatovistaOptimized } from 'api/catalogos/Candidatos';
import { render } from '@testing-library/react';
import { postObtenerReporte } from 'api/reporteador';
import Previewer from 'components/Previewer';
import ModalInforme from './Entrevistas/ModalInforme';

export const informepsicometricopermission = {
  permissionModel: 'informepsicometrico',
  catalogsModels: [],
  tabsModels: [],
};

const EntrevistaInforme = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [disableFields, setDisableFields] = useState(false);
  const [pageActual, setPageActual] = useState(1);
  const [candidato, SetCandidato] = useState([]);
  const [visibleInforme, setVisibleInforme] = useState(false);
  const [resultados, setResultados] = useState([]);
  const [base64, setBase64] = useState();
  const [visiblePreview, setVisiblePreview] = useState(false);

  const formInstances = [
    form,
  ];

  const baseURI = '/nominas/informe-psicometrico';

  const fetchPaginated = async (page = 1, q = null) => {
    try {
      setLoading(true);
      const response = await API.get(baseURI, { params: { page, ...q } });
      const { results } = response.data;
      setSelectedRowKeys([]);
      setPageActual(page);
      setData({ ...response.data, results });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const fetchData = async (page = 1, q = null) => {
    setLoading(true);
    const _data = await API.get(baseURI, { params: { page, ...q } });
    const { results } = _data.data;
    setData({ ..._data.data, results });
    setLoading(false);
  };
  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _candidato,
        _estados,
        _data,
        _resultados,
      ] = await Promise.all([
        getCandidatovistaOptimized(),
        getEstadosGlobales(),
        getEntrevistasInforme(),
        getResultados(),
      ]);
      if (mounted) {
        setResultados(_resultados);
        SetCandidato(_candidato);
        const mergedData = _data.results.map((item) => {
          const cand = _candidato.find((c) => c.id === item.candidato);

          return {
            ...item,
            // Candidatos
            candidato_numero_y_nombre_completo: cand?.candidato_numero_y_nombre_completo,
            candidato_fuente_de_reclutamiento_descripcion: cand?.candidato_fuente_de_reclutamiento_descripcion,
            candidato_estado_del_candidato_descripcion: cand?.candidato_estado_del_candidato_descripcion,
            cita_fecha_y_hora: cand?.cita_fecha_y_hora,
            cita_estado_de_cita_descripcion: cand?.cita_estado_de_cita_descripcion,

            // Vacante
            vacante__folio: cand?.vacante__folio,
            vacante_directorio_de_area_clave_y_nombre: cand?.vacante_directorio_de_area_clave_y_nombre,
            vacante_plaza_clave_y_descripcion: cand?.vacante_plaza_clave_y_descripcion,
            vacante_puesto_clave_y_descripcion: cand?.vacante_puesto_clave_y_descripcion,
            vacante_motivo_de_reclutamiento_nombre: cand?.vacante_motivo_de_reclutamiento_nombre,
            vacante_estado_global_descripcion: cand?.vacante_estado_global_descripcion,
            vacante_fecha_de_solicitud: cand?.vacante_fecha_de_solicitud,

            // Solicitante
            solicitante: cand?.solicitante,
            solicitante_directorio_de_area_clave_y_nombre: cand?.solicitante_directorio_de_area_clave_y_nombre,
            solicitante_plaza_clave_y_descripcion: cand?.solicitante_plaza_clave_y_descripcion,
            solicitante_puesto_clave_y_descripcion: cand?.solicitante_puesto_clave_y_descripcion,
          };
        });
        setData({ ..._data, results: mergedData });

        setEstados(_estados);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    setSelectedData({});
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    if (!([1].includes(key))) {
      const match = responseData || data.find((item) => item.id === key);
      const _nivelDeEstudio = await getNivelDeEstudio(match.id);
      setTimeout(() => {
        if (_nivelDeEstudio) {
          form.resetFields();
          setTimeout(() => {
            form.setFieldsValue(formatReceived(_nivelDeEstudio));
            setDisableFields(_nivelDeEstudio?.estados_globales !== ESTATUS_ACTIVO);
            setVisible(true);
          });
        }
      });
    } else {
      message.warn('Este campo no es editable');
    }
    setLoading(false);
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;
      // eslint-disable-next-line max-len
      const saved = await (key ? patchNivelDeEstudio(key, values) : postNivelDeEstudio(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteNivelDeEstudio(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });
    form.setFieldsValue(record);
  };

  const handleKeyPress = (e) => {
    if (/\d/.test(e.key)) {
      e.preventDefault();
    }
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    form.resetFields();
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    const [key] = selectedRowKeys;
    if (key) {
      setVisibleAlert(true);
    } else {
      setVisibleAlert(false);
      message.warn('Este campo no se puede borrar');
    }
  };

  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar un Nivel de Estudios ya autorizado');
        return;
      }
      const saved = await autorizarNivelDeEstudio(key);
      if (saved) {
        const _data = await getNivelesDeEstudios();
        setData(formatReceived(_data));
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Candidatos',
      children: [
        {
          title: 'Número y Nombre',
          dataIndex: 'candidato_numero_y_nombre_completo',
          key: 'candidato_numero_y_nombre_completo',
          width: 280,
        },
        {
          title: 'Fuente de Reclutamiento',
          dataIndex: 'candidato_fuente_de_reclutamiento_descripcion',
          key: 'candidato_fuente_de_reclutamiento_descripcion',
          width: 220,
        },
        {
          title: 'Estatus',
          dataIndex: 'candidato_estado_del_candidato_descripcion',
          key: 'candidato_estado_del_candidato_descripcion',
          width: 150,
        },
      ],
    },
    {
      titleText: 'Citas',
      children: [
        {
          title: 'Fecha',
          dataIndex: 'cita_fecha_y_hora',
          key: 'cita_fecha_y_hora',
          width: 140,
          render: (val) => (val ? new Date(val).toLocaleDateString() : '-'),
        },
        {
          title: 'Hora',
          dataIndex: 'cita_fecha_y_hora',
          key: 'cita_hora',
          width: 120,
          render: (val) => (val
            ? new Date(val).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
            : '-'),
        },
        {
          title: 'Estatus',
          dataIndex: 'cita_estado_de_cita_descripcion',
          key: 'cita_estado_de_cita_descripcion',
          width: 150,
        },
      ],
    },
    {
      titleText: 'Resultado General',
      children: [
        {
          title: 'Resultado',
          dataIndex: 'resultado_general',
          key: 'resultado_general',
          width: 200,
          render: (val) => resultados.find((e) => e.id === val)?.descripcion || 'N/A',

        },
        {
          title: 'Fecha de Resultado',
          dataIndex: '',
          key: '',
          width: 180,
        },
      ],
    },
    {
      titleText: 'Vacante',
      children: [
        {
          title: 'Folio', dataIndex: 'vacante__folio', key: 'vacante__folio', width: 100,
        },
        {
          title: 'Área',
          dataIndex: 'vacante_directorio_de_area_clave_y_nombre',
          key: 'vacante_directorio_de_area_clave_y_nombre',
          width: 240,
        },
        {
          title: 'Plaza',
          dataIndex: 'vacante_plaza_clave_y_descripcion',
          key: 'vacante_plaza_clave_y_descripcion',
          width: 220,
        },
        {
          title: 'Puesto',
          dataIndex: 'vacante_puesto_clave_y_descripcion',
          key: 'vacante_puesto_clave_y_descripcion',
          width: 220,
        },
        {
          title: 'Motivo',
          dataIndex: 'vacante_motivo_de_reclutamiento_nombre',
          key: 'vacante_motivo_de_reclutamiento_nombre',
          width: 240,
        },
        {
          title: 'Estado',
          dataIndex: 'vacante_estado_global_descripcion',
          key: 'vacante_estado_global_descripcion',
          width: 150,
        },
      ],
    },
    {
      titleText: 'Solicitante',
      children: [
        {
          title: 'Nombre', dataIndex: 'solicitante', key: 'solicitante', width: 260,
        },
        {
          title: 'Área',
          dataIndex: 'solicitante_directorio_de_area_clave_y_nombre',
          key: 'solicitante_directorio_de_area_clave_y_nombre',
          width: 240,
        },
        {
          title: 'Plaza',
          dataIndex: 'solicitante_plaza_clave_y_descripcion',
          key: 'solicitante_plaza_clave_y_descripcion',
          width: 220,
        },
        {
          title: 'Puesto',
          dataIndex: 'solicitante_puesto_clave_y_descripcion',
          key: 'solicitante_puesto_clave_y_descripcion',
          width: 220,
        },
      ],
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    nombre: [
      requiredRule,
      {
        pattern: NOMBRES_PATTERN,
        message: 'Ingrese un nombre válido',
      },
    ],
  };
  const onClickPreview = async () => {
    const idsCandidatos = selectedRowKeys
      .map((rowId) => {
        const row = data?.results?.find((e) => e.id === rowId);
        return row?.candidato; //  aquí toma el id del candidato
      })
      .filter((id) => !!id);

    if (idsCandidatos.length === 0) {
      message.warning('No se encontraron candidatos válidos para el reporte.');
      return;
    }

    const values = {
      ID: 1005, // reporte correcto
      Parametros: [
        {
          Nombre: 'informe_psicometrico_por_candidato',
          TipoParametro: 'EnteroLista',
          Valores: idsCandidatos.map((id) => ({ Value: id })),
        },
      ],
    };

    const file = await postObtenerReporte(values);

    if (file) {
      setBase64(file);
      setVisiblePreview(true);
    } else {
      message.error('Error al generar el reporte. Inténtalo de nuevo más tarde.');
    }
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data?.results || []}
          pagination={false}
          paginationCallback={fetchPaginated}
          count={data?.count || 0}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
            //  aquí añadimos el doble click
          onRow={(record) => ({
            onClick: () => {
              handleOnRowClick(record);
            },
            onDoubleClick: () => {
              setSelectedRowKeys([record.id]);
              setSelectedData(record);
              setVisibleInforme(true);
            },
          })}
          controls={{
            // onClickAdd,
            // onClickEdit: () => onClickEdit(),
            onClickDelete,
          }}
          customActions={[
            {
              onClick: () => {
                if (selectedData?.id) {
                  setVisibleInforme(true);
                } else {
                  message.warn('Selecciona un registro válido');
                }
              },
              icon: <FileSearchOutlined />,
              text: 'Informe Psicométrico',
              disabledBySelection: true,
              className: 'primary',
            },
            {
              onClick: onClickPreview,
              icon: <EyeOutlined />,
              text: 'Ver Reporte',
              disabled: selectedRowKeys.length === 0,
            },

          ]}
          disableDelete={selectedData?.estados_globales === ESTATUS_AUTORIZADO}
          permission={permission}
          allowExportPDF={false}
        />

        <Modal
          open={open}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Nivel de Estudio`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
              allowSave={!disableFields}
            />
            )}
          onCancel={onCancel}
          forceRender
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            scrollToFirstError
            name="general"
            initialValues={{
              estados_globales: ESTATUS_ACTIVO,
            }}
          >
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="nombre"
                rules={rules.nombre}
                label="Nombre"
                onKeyPress={handleKeyPress}
                hasFeedback
              >
                <Input
                  allowClear
                  disabled={disableFields}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="estados_globales"
                label="Estatus"
                rules={rules.required}
                hasFeedback
              >
                <Select
                  labelProp="descripcion"
                  keyProp="id"
                  dataSource={estados}
                  activeInactive={selectedData?.estados_globales === ESTATUS_ACTIVO}
                  disabled={selectedRowKeys.length <= 0 || disableFields}
                  onChange={(val) => setVisibleConfirmInactivo(val === ESTATUS_INACTIVO)}
                />
              </Form.Item>
            </Col>
            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Form>
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Nivel de Estudio ${form.getFieldValue('nombre')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => setVisibleAutorizar(false)}
          contentTitle={`Autorizar el Nivel de Estudios ${selectedData?.nombre}`}
          open={visibleAutorizar}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={() => setVisibleConfirmInactivo(false)}
          ConfirmInactive
          onCancel={() => {
            form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
            setVisibleConfirmInactivo(false);
          }}
          open={visibleConfirmInactivo}
          contentTitle={`Inactivar el Nivel de Estudios ${selectedData?.nombre}`}
          loading={loading}
        />
        <Modal
          open={visibleInforme}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          width={1000}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Informe Psicométrico`}
              // onFinish={() => resultadoForm.submit()} // dispara el onFinishResultado
              onCancel={() => setVisibleInforme(false)}
              loading={loading}
              allowSave
            />
  )}
          onCancel={() => setVisibleInforme(false)}
          forceRender
          destroyOnClose
        >
          <ModalInforme
            selectedData={selectedData} // ahora le pasamos TODO el objeto
            onClose={() => setVisibleInforme(false)}
          />
        </Modal>

        <Modal
          title="Vista Previa del Reporte"
          open={visiblePreview}
          onCancel={() => setVisiblePreview(false)}
          footer={null}
          width="80%"
          style={{ top: 20 }}
          destroyOnClose
        >
          <div style={{ height: '75vh', backgroundColor: '#f5f5f5', padding: '10px' }}>
            {base64 ? (
              <iframe
                src={base64}
                style={{
                  width: '100%',
                  height: '100%',
                  border: 'none',
                  backgroundColor: 'white',
                  borderRadius: '4px',
                }}
                title="Vista Previa de Informe Psicométrico"
              />
            ) : (
              <Empty description="No hay reporte para mostrar." style={{ marginTop: '10%' }} />
            )}
          </div>
        </Modal>
      </Spin>
    </Row>
  );
};

export default EntrevistaInforme;
